export default __webpack_public_path__ + "static/media/young_coconut_juice.c21ff0b3.JPG";